import { render, staticRenderFns } from "./DiscardChangesModal.vue?vue&type=template&id=6b1b081c&scoped=true&"
import script from "./DiscardChangesModal.vue?vue&type=script&lang=js&"
export * from "./DiscardChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscardChangesModal.vue?vue&type=style&index=0&id=6b1b081c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b081c",
  null
  
)

export default component.exports